function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetpassword({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.8,343.75C94.35,360,97.13,385,93.64,407c-.09.5-.86.36-.86-.1,0-5,.15-10,.13-14.89-.09-.23-.16-.44-.25-.67-4.32-3.14-8.3-6.69-10.76-11.55-2.76-5.44-3.85-11.57-6-17.25-.2-.54.38-.38.76-.1,10.07,7.42,13.28,15.41,16.17,26.09a89.35,89.35,0,0,0-1.75-16.62c-2.18-10.14-6.48-20.18-13.76-27.7A.31.31,0,0,1,77.8,343.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.69,345.64c-2.85.1-4.64,4.65-6.86,6a2.14,2.14,0,0,1-3.14-.5c-2.2-3.07.82-6.85,3.66-9-2,.83-3.71,2.3-5.9,2.71a2.05,2.05,0,0,1-2.67-1.59c-1-4.18,4.29-6,7.89-6.13-1.75-1.22-6.75-4.52-4.09-6.14s8.56,3.09,10.48,4.64c2.81,2.29,6.17,5.7,6.3,9.27C80.52,349.08,76.88,346.52,74.69,345.64Z",
    style: {
      fill: "#002B44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.69,345.64c-2.85.1-4.64,4.65-6.86,6a2.14,2.14,0,0,1-3.14-.5c-2.2-3.07.82-6.85,3.66-9-2,.83-3.71,2.3-5.9,2.71a2.05,2.05,0,0,1-2.67-1.59c-1-4.18,4.29-6,7.89-6.13-1.75-1.22-6.75-4.52-4.09-6.14s8.56,3.09,10.48,4.64c2.81,2.29,6.17,5.7,6.3,9.27C80.52,349.08,76.88,346.52,74.69,345.64Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.51,346.34c-3.64-1.65-10.63.73-11.23-.65-1.2-2.8,4.38-4.73,7.4-5.1-2.78-.75-8.1-1.95-7.94-4.63.2-3.27,8.17-.46,12.2,2.63,5.08,3.9,5,7.66,4.2,8.41C79,348,76.11,346.62,75.51,346.34Z",
    style: {
      fill: "#002B44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.49,342.15c-17.16,15.56-20.89,40.5-18.24,62.58.08.5.85.39.87-.07.19-5,.23-10,.43-14.89.1-.22.18-.43.28-.65,4.44-3,8.54-6.37,11.19-11.14,3-5.33,4.28-11.41,6.61-17,.22-.54-.37-.4-.76-.14-10.34,7-13.85,14.9-17.14,25.46a88.65,88.65,0,0,1,2.38-16.55c2.56-10,7.24-19.91,14.8-27.15C116.19,342.33,115.79,341.87,115.49,342.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.53,344.15c2.84.21,4.45,4.82,6.61,6.24a2.13,2.13,0,0,0,3.16-.38c2.32-3-.55-6.88-3.31-9.1,2,.91,3.62,2.44,5.79,2.93a2.05,2.05,0,0,0,2.73-1.49c1.12-4.14-4-6.2-7.65-6.43,1.79-1.14,6.92-4.25,4.32-6s-8.67,2.76-10.65,4.24c-2.9,2.17-6.38,5.45-6.64,9C112.56,347.37,116.3,344.94,118.53,344.15Z",
    style: {
      fill: "#002B44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.53,344.15c2.84.21,4.45,4.82,6.61,6.24a2.13,2.13,0,0,0,3.16-.38c2.32-3-.55-6.88-3.31-9.1,2,.91,3.62,2.44,5.79,2.93a2.05,2.05,0,0,0,2.73-1.49c1.12-4.14-4-6.2-7.65-6.43,1.79-1.14,6.92-4.25,4.32-6s-8.67,2.76-10.65,4.24c-2.9,2.17-6.38,5.45-6.64,9C112.56,347.37,116.3,344.94,118.53,344.15Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.68,344.82c3.7-1.51,10.59,1.13,11.24-.22,1.31-2.76-4.2-4.89-7.2-5.38,2.81-.64,8.17-1.64,8.11-4.32-.08-3.28-8.14-.77-12.29,2.16-5.22,3.7-5.33,7.46-4.52,8.24C114.13,346.38,117.06,345.07,117.68,344.82Z",
    style: {
      fill: "#002B44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98,383.25a169.38,169.38,0,0,1-5.33,24.61.61.61,0,0,1-1.2-.25c1.13-7.58,3.18-15,4.31-22.61a114.13,114.13,0,0,0,1.32-23.21c-.73-12.77-4.2-26.37-12.53-36.36-.19-.24.2-.58.39-.36,16.69,19.47,14,43.33,14,45.47,2.37-8.06,4.8-17.29,13.74-25.5.39-.35.69-.18.62.42-1.6,14.94-5.75,22.75-14.42,30.74C98.63,378.56,98.32,380.92,98,383.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.36,327.66c-3-1.33-7.14,2.49-10.11,2.76-1.57.14-2.74-.48-3-2.1-.74-4.29,4.3-6.7,8.31-7.47-2.53-.16-5,.52-7.49-.15a2.37,2.37,0,0,1-2-3c1.1-4.82,7.49-4.11,11.27-2.39-1.2-2.14-4.73-8.08-1.16-8.43s7.33,7.52,8.54,10.1c1.77,3.78,3.53,9,1.87,12.78C88.69,334.17,86.2,329.67,84.36,327.66Z",
    style: {
      fill: "#002B44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.36,327.66c-3-1.33-7.14,2.49-10.11,2.76-1.57.14-2.74-.48-3-2.1-.74-4.29,4.3-6.7,8.31-7.47-2.53-.16-5,.52-7.49-.15a2.37,2.37,0,0,1-2-3c1.1-4.82,7.49-4.11,11.27-2.39-1.2-2.14-4.73-8.08-1.16-8.43s7.33,7.52,8.54,10.1c1.77,3.78,3.53,9,1.87,12.78C88.69,334.17,86.2,329.67,84.36,327.66Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.87,328.81c-3-3.55-11.4-4.6-11.33-6.33.16-3.52,6.93-2.7,10.25-1.57-2.5-2.18-7.42-6.1-5.91-8.8,1.86-3.29,8.71,3.64,11.33,8.87,3.31,6.6,1.39,10.48.14,10.84C87.63,332.31,85.35,329.39,84.87,328.81Z",
    style: {
      fill: "#002B44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.93,387.75,116.29,444H71.49c.92-5,9.26-56.32,9.26-56.32Z",
    style: {
      fill: "#002B44"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Fingerprint--inject-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184,212.92a32.72,32.72,0,0,0-4.43-9.41,43.64,43.64,0,0,0-7.09-7.72c-10.63-9.25-25.28-12.83-39.13-11.88a51.72,51.72,0,0,0-18.3,4.55,32.16,32.16,0,0,0-7.74,5.08c-2.15,1.91-4.57,4.26-5.57,7a.48.48,0,0,0,.76.52c1.27-1,2.34-2.26,3.55-3.36a34.54,34.54,0,0,1,3.88-3,47.71,47.71,0,0,1,8.5-4.44c11.89-4.8,26-4.68,38-.34a49.81,49.81,0,0,1,15.84,9.41,47.88,47.88,0,0,1,6,6.37,71.39,71.39,0,0,1,5.33,7.36C183.78,213.2,184.09,213.14,184,212.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.23,194a20.54,20.54,0,0,0-4.47-5.05,43,43,0,0,0-5.82-3.6,65.66,65.66,0,0,0-24-7.48,38.41,38.41,0,0,0-12.15.6,51,51,0,0,0-5.59,1.59,19.58,19.58,0,0,0-5.26,2.45.25.25,0,0,0,.2.43c2.14-.44,4.19-1.23,6.34-1.64s4.16-.49,6.26-.69c24.57-2.28,42.34,12.91,44.08,13.82A.3.3,0,0,0,175.23,194Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.22,271.77c5,3.23,10.92.87,14.84-2.92,4.08-3.94,6.86-9.1,9-14.29,2-4.74,3.41-9.69,5-14.58s3-10,5.52-14.47a18.47,18.47,0,0,1,11-8.81,22.14,22.14,0,0,1,15.23,1.37,21.75,21.75,0,0,1,6.73,4.65,20.08,20.08,0,0,1,4.05,6.61c2.11,5.28,3.17,10.9,4.45,16.41,1.05,4.56,3.23,8.67,7.5,10.92,3.64,1.92,8.12,2.5,11.82.43a.25.25,0,0,0-.16-.47A15.42,15.42,0,0,1,172,253a13.75,13.75,0,0,1-3.65-6.72c-.8-3-1.4-6.09-2.22-9.11-1.36-5-2.71-10.47-6-14.63a25.36,25.36,0,0,0-12.93-8.28,23.12,23.12,0,0,0-14.81.64A21,21,0,0,0,121.59,225c-4.72,9-6.24,19.26-9.88,28.68a41.58,41.58,0,0,1-7.38,12.81c-3.33,3.72-8.68,6.48-13.66,4.41A.49.49,0,0,0,90.22,271.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.13,256c2.3.31,4.41-1.42,5.48-3.32a38,38,0,0,0,3.32-8.64,141.66,141.66,0,0,1,6-18.26c4-9.31,10.23-18.29,19.2-23.45a35.29,35.29,0,0,1,29.65-2.73,35.69,35.69,0,0,1,12.38,7.68,40.73,40.73,0,0,1,8.68,12.55,104.94,104.94,0,0,1,5.1,15c.59,2.05,1.42,4.54,3.4,5.65a3.68,3.68,0,0,0,4.71-.68c.11-.13-.07-.27-.19-.19a3,3,0,0,1-3.7-.3,5.88,5.88,0,0,1-2-3.55c-.67-2.76-1.21-5.54-2-8.29a56.19,56.19,0,0,0-6.91-15.79,38.15,38.15,0,0,0-53.12-10.4c-8.64,5.86-14.49,14.89-18.36,24.42a133.52,133.52,0,0,0-5,16,75,75,0,0,1-2.44,8.11,26.1,26.1,0,0,1-1.6,3.38,3.08,3.08,0,0,1-2.52,1.82A.48.48,0,0,0,89.13,256Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.92,276.09a.44.44,0,0,0,.35.49,15.54,15.54,0,0,0,2.47.38,10.45,10.45,0,0,0,1.12,0c4.41-.22,9-2.72,13.62-7.43A50.44,50.44,0,0,0,119,255.9a70.67,70.67,0,0,0,4.34-13.42c.32-1.29.65-2.59,1-3.87,1.09-4.1,3.07-10,7.54-13.72a13.12,13.12,0,0,1,11-2.78,22.25,22.25,0,0,1,14.53,10.15,20.08,20.08,0,0,1,2.54,13.91,27.85,27.85,0,0,1-7.25,13.75,43.63,43.63,0,0,1-13.36,9.37c-2.12,1-4.93,2.33-7.81,3.39l-1.65.61c-2.1.77-4.26,1.55-6.33,2.46a.62.62,0,0,0,.37,1.17c1.45-.31,2.88-.71,4.21-1.1,9.65-2.77,21.67-7.25,29-17.36a27.46,27.46,0,0,0,5.52-15.14,22.46,22.46,0,0,0-4.44-14,24.66,24.66,0,0,0-15.79-9.8,15.43,15.43,0,0,0-11.92,3c-3.7,2.87-6.42,7.44-8.31,14-.52,1.78-1,3.6-1.43,5.36a72.09,72.09,0,0,1-4,12.44,48.2,48.2,0,0,1-9.85,14.06c-3.35,3.3-8.57,7.23-14.44,7.24A.52.52,0,0,0,91.92,276.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,261.77a8.15,8.15,0,0,0,7.14-1.8c2.19-1.75,3.32-4.66,4.22-7.24,2.09-6,3.71-12.2,5.79-18.23,3.23-9.4,8-19,16.47-24.66a32,32,0,0,1,26.11-4.1,28.43,28.43,0,0,1,12.77,7.67,40,40,0,0,1,7.51,12.12c.93,2.24,1.73,4.52,2.44,6.84a74.5,74.5,0,0,0,2.32,7.25c1.64,3.94,5.77,8.67,10.53,6.72a.39.39,0,0,0-.14-.74,9.19,9.19,0,0,1-6.67-3.87c-1.69-2.38-2.34-5.32-3.11-8.09a64.16,64.16,0,0,0-5.92-14.84,34.33,34.33,0,0,0-9.21-10.63,32.6,32.6,0,0,0-13.76-5.74,34.57,34.57,0,0,0-26.08,6.29c-8.23,6.15-12.92,15.79-16.13,25.3-1.81,5.34-3.21,10.79-4.87,16.17-1.26,4.1-3.49,11-9.09,10.09A.77.77,0,0,0,90,261.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.59,265.69a7.72,7.72,0,0,0,2.34,1.79c1.84.92,4.53.62,6.37-.12a12.42,12.42,0,0,0,5.45-4.85,42.37,42.37,0,0,0,3.56-7.17c1.15-2.77,2.15-5.62,3.13-8.46,2-5.71,3.79-11.47,6-17.11,1.92-5,4.31-9.77,8.33-13.41a25.47,25.47,0,0,1,27-4.75A24.87,24.87,0,0,1,163,221c3,4.57,4.36,9.9,5.68,15.11,1.18,4.64,2.13,9.65,5.1,13.54,2.47,3.25,7.73,5.82,11.2,2.44a.2.2,0,0,0-.22-.33c-2.48,1.23-5.39.39-7.46-1.29a14.31,14.31,0,0,1-4.14-6.22c-2.05-5.31-2.86-11-4.74-16.41a31,31,0,0,0-7.82-12.67,29.25,29.25,0,0,0-12.26-7,27.93,27.93,0,0,0-26.57,7.1c-3.81,3.83-6.2,8.66-8.13,13.65-2.1,5.47-3.8,11.09-5.7,16.64-1,2.84-2,5.66-3.11,8.47a44,44,0,0,1-3.15,7,10.88,10.88,0,0,1-5.14,4.69,6.26,6.26,0,0,1-6.28-.71C89.8,264.66,89.25,265.31,89.59,265.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.16,236.83a33.82,33.82,0,0,0,0-3.9,48.58,48.58,0,0,0-13-28.63,45.43,45.43,0,0,0-25.91-14,48.48,48.48,0,0,0-28.66,4.4,47.86,47.86,0,0,0-20.83,20,49.18,49.18,0,0,0-6.29,28.1c0,.21.34.17.35,0a59.71,59.71,0,0,1,9.93-29.56A47.77,47.77,0,0,1,122.89,196a45,45,0,0,1,27-2.26,43.67,43.67,0,0,1,23.55,15.07A50.65,50.65,0,0,1,181,221.9a100.76,100.76,0,0,1,4.33,15C185.48,237.28,186.13,237.28,186.16,236.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.89,272.9c1.1-1.62,3.46-.19,4.68.49,1.83,1,3.8,2.37,6,2a.14.14,0,0,1,.09.27,5.33,5.33,0,0,1-4.6.06,23.74,23.74,0,0,1-2.28-1.08,9.69,9.69,0,0,0-2.23-.94,1.57,1.57,0,0,0-.43,0c-.15,0-.11,0-.13.05-.14.26.08.81.16,1.07a9.65,9.65,0,0,0,.77,1.95,14.71,14.71,0,0,0,2.61,3.46,21.07,21.07,0,0,0,1.85,1.68c.66.53,1.44.93,2.07,1.49a.22.22,0,0,1-.21.39,9,9,0,0,1-2.16-1,15.13,15.13,0,0,1-2-1.4,13.5,13.5,0,0,1-3.15-3.74,12.07,12.07,0,0,1-1-2.24A2.78,2.78,0,0,1,170.89,272.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.24,276a14.49,14.49,0,0,1,3.31,2.1q.67.56,1.38,1.05c.23.16.48.31.72.45a6.46,6.46,0,0,0,.76.33.24.24,0,0,1,0,.46c-1.19.29-2.44-.49-3.34-1.17a14.57,14.57,0,0,1-3-2.92C173.93,276.2,174.05,276,174.24,276Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.07,279.67a.17.17,0,0,0,0,.07.38.38,0,0,0,.3.34,4.68,4.68,0,0,0,.9.14,11.07,11.07,0,0,0,3.13-.4,21.12,21.12,0,0,0,4.14-1.45,30,30,0,0,0,7.12-4.81c7.25-6.34,12.35-15.37,15.16-26.86.18-.76.37-1.53.55-2.29,1-4.15,2-8.43,4.3-12a13.94,13.94,0,0,1,4.8-4.57,13.3,13.3,0,0,1,6.54-1.4.53.53,0,0,0,.22-1c-2.59-1.27-5.81-.07-7.07.5a16,16,0,0,0-5.72,4.57c-3,3.71-4.12,8.47-5.2,13.07l-.28,1.15a65.49,65.49,0,0,1-5.31,15A43.52,43.52,0,0,1,110,272.11a30.3,30.3,0,0,1-6.32,4.46,27.29,27.29,0,0,1-3.64,1.51c-.42.14-.85.25-1.28.37a12.09,12.09,0,0,0-2.45.86A.42.42,0,0,0,96.07,279.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.16,274a.42.42,0,0,0,.2.39.37.37,0,0,0,.2.07.42.42,0,0,0,.37-.19,7.67,7.67,0,0,1,3.34-2.38c1.18-.55,2.41-1,3.6-1.49l.54-.22c3.27-1.28,5.93-2.42,8.37-3.59,10.82-5.19,17.27-11.91,19.2-20a18,18,0,0,0-1.52-12.82,15.08,15.08,0,0,0-9.4-7.75.51.51,0,0,0-.6.3.46.46,0,0,0,.19.59,20.4,20.4,0,0,1,8.62,9.84c2.19,5.8,1.13,15.28-9.09,22.95a61.57,61.57,0,0,1-12.27,6.72c-2.16.95-4.6,2-6.94,3.27a18.23,18.23,0,0,0-2.76,1.71,9.16,9.16,0,0,0-2,2.38A.36.36,0,0,0,121.16,274Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.87,281.7a10.29,10.29,0,0,0,4.85,1.46,18.51,18.51,0,0,0,9-2.18,42.72,42.72,0,0,0,11.05-8.39c.31-.32.6-.65.9-1l.27-.29a.62.62,0,0,0,.19-.14c2.53-2.52,6-3.92,9.33-5.28,1.16-.47,2.37-1,3.5-1.48,5.59-2.6,9.4-5.18,12.34-8.38a19.53,19.53,0,0,0,5.35-11.34c.35-3.7-.52-8.86-4.09-11.26s-8.09-.69-10.74,2.2c-3.08,3.37-4.65,8.13-5.92,12l-.44,1.35a71.94,71.94,0,0,1-4.42,11.25,46.83,46.83,0,0,1-7.35,10.27,46.3,46.3,0,0,1-9.78,7.88c-4.74,2.83-9.36,3.69-13.71,2.59h-.08a.45.45,0,0,0-.43.27A.4.4,0,0,0,92.87,281.7ZM123.17,266c.72-1,1.35-2,1.91-3a58.49,58.49,0,0,0,5-11.71c.21-.65.41-1.3.63-2,1.15-3.64,2.34-7.41,4.45-10.59a9.52,9.52,0,0,1,4.33-3.84,6.28,6.28,0,0,1,2.59-.43,4.44,4.44,0,0,1,2.84,1.17c3,2.8,3.19,7.93,2,11.77a20.52,20.52,0,0,1-7.11,9.66c-3.71,2.95-8.1,4.92-12,6.66l-.37.16C126.05,264.58,124.56,265.25,123.17,266Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.68,259.34a.47.47,0,0,0,.16.49.44.44,0,0,0,.26.1.42.42,0,0,0,.34-.14c.22-.22,1.84-1.38,2.62-1.91.25-.17.51-.33.76-.51.53-.35,1.08-.71,1.6-1.11a37.47,37.47,0,0,0,4.38-3.89c2.62-2.75,3.85-5.5,3.63-8.19a3.56,3.56,0,0,0-2-3.18,3.61,3.61,0,0,0-4.06,1.29,14.15,14.15,0,0,0-2.1,4c-.46,1.16-.87,2.37-1.28,3.53l-.33.94a66.84,66.84,0,0,1-3.93,8.14A.43.43,0,0,0,129.68,259.34Zm5.11-6.92a58.63,58.63,0,0,1,3.32-7.18l.06-.1c.34-.6,1.15-2,1.93-2.16h.17a.83.83,0,0,1,.45.18c.68.53.58,2,.26,3.11-.74,2.66-3,4.81-4.76,6.54l-1.4,1.34c-.48.45-.95.91-1.42,1.37C134,254.41,134.43,253.32,134.79,252.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,304.46A111.37,111.37,0,0,0,131.36,315a.11.11,0,0,0,.19.09c1.95-2.9,3.57-6,5.4-9,1.2-1.93,3.37-6.44,6.3-5.71,1.23.3,2.11,1.66,2.79,2.63a41.81,41.81,0,0,0,2.9,3.86c1.6,1.82,4.6,4.2,7.22,3.56.12,0,.19-.22.07-.28-.7-.37-1.44-.6-2.13-1A10.71,10.71,0,0,1,152,307.6a23.42,23.42,0,0,1-3.22-4.12c-1.5-2.32-3.25-5.38-6.51-5C139.25,298.83,137.19,302,136,304.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.73,284.29c3.17,4.17,8.84,3.43,12.94,1.21a44,44,0,0,0,6.66-4.75,49.85,49.85,0,0,1,7-4.94.12.12,0,0,0-.07-.23c-5.07.81-8.73,5-12.86,7.64-3.88,2.5-9.51,4-13.51.84C92.79,283.94,92.63,284.16,92.73,284.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.29,292.19c.32,0,.45-.48.12-.56-5.12-1.27-9.16-5.11-11.64-9.68a32.09,32.09,0,0,1-3.79-13.5A25.18,25.18,0,0,1,161.52,258a7.78,7.78,0,0,1,1.68-3,2,2,0,0,1,3-.16,19.38,19.38,0,0,1,1.47,2.39,13.85,13.85,0,0,0,4.58,4.3,12.82,12.82,0,0,0,6,1.73,12,12,0,0,0,6.39-1.65c.13-.08.07-.33-.09-.28a14.12,14.12,0,0,1-15-4.5c-1.22-1.57-1.88-4-4.21-4.18s-3.95,1.68-4.87,3.61A26.35,26.35,0,0,0,158.53,271C159.76,279.81,165.06,291.72,175.29,292.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.29,311.68a7.67,7.67,0,0,0-.43,2.84.16.16,0,0,0,.28.06,8.74,8.74,0,0,0,1.05-2.35c.31-.86.63-1.72,1-2.56a18.26,18.26,0,0,1,1.28-2.44,3.42,3.42,0,0,1,.64-.93l.07-.05.16.16a4.58,4.58,0,0,1,.42.46,44.81,44.81,0,0,0,3.28,4c1,.93,2.59,1.94,4,1.62a.11.11,0,0,0,0-.2,10,10,0,0,1-2.21-1.54,14.63,14.63,0,0,1-1.67-2.08c-.57-.78-1.08-1.61-1.7-2.36s-1.31-1.72-2.3-1.72-1.46.89-1.85,1.6a17.07,17.07,0,0,0-1.2,2.65C138.84,309.78,138.54,310.72,138.29,311.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.68,286.8a.17.17,0,0,0,.15-.3,28.08,28.08,0,0,1-3.4-3.41,45.12,45.12,0,0,1-2.74-4,43.89,43.89,0,0,1-4.28-7.58,9.75,9.75,0,0,1-.92-4.13c.19-2,2.2-.54,3.07.21a27.7,27.7,0,0,0,3.1,2.62A11.57,11.57,0,0,0,180,272a11.15,11.15,0,0,0,3.53-1.27c.25-.11.07-.45-.18-.37a10.27,10.27,0,0,1-3,.28,15.74,15.74,0,0,1-2.48-.15,11.35,11.35,0,0,1-4.75-1.91c-1.7-1.21-4.82-5.27-7.2-3.31-2.06,1.69-.47,5.62.36,7.54a46,46,0,0,0,5,8.24C172.88,283.25,175,285.88,177.68,286.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.11,294.45a9.08,9.08,0,0,0,6.36-1.07c.41-.22.79-.47,1.19-.72-.21.24-.41.47-.6.71a11.28,11.28,0,0,0-2.48,5.87.14.14,0,0,0,.25.09c1.12-1.71,2.27-3.43,3.55-5s2.77-3.12,4-4.77a.45.45,0,0,0-.45-.69c-2.12.48-3.71,2-5.59,3a30,30,0,0,1-6.26,2.43C99,294.3,99,294.43,99.11,294.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.32,303.81a56.93,56.93,0,0,0-3,6.55.23.23,0,0,0,.41.21c1.7-2.29,3.07-4.83,4.65-7.21s3.15-4.54,4.87-6.71a39.51,39.51,0,0,1,9.8-9,25.2,25.2,0,0,1,3-1.64,7.77,7.77,0,0,1,3.49-1c2.22.12,3.66,2.25,4.65,3.9,2.39,4,4.43,8.22,8.13,11.27A12.54,12.54,0,0,0,164,303a4.46,4.46,0,0,0,2.73-.08c.27-.17.44-.42.17-.66-.09-.07-.23,0-.17.14s-1.29-.13-1.35-.15l-.86-.24a10.37,10.37,0,0,1-1.75-.72,16.85,16.85,0,0,1-3-2,23.17,23.17,0,0,1-4.9-6.18c-1.15-1.95-2.17-4-3.45-5.87a9,9,0,0,0-4.33-3.75c-2.28-.74-4.59.08-6.65,1a29.54,29.54,0,0,0-5.61,3.33,37.79,37.79,0,0,0-9,9.75A68.4,68.4,0,0,0,122.32,303.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.05,308.27a22.33,22.33,0,0,0-1.48,5.21.13.13,0,0,0,.24.08c1-1.74,1.7-3.67,2.74-5.41s2-3.46,3-5.13a52.78,52.78,0,0,1,6.47-8.37c1.15-1.17,2.5-2.17,4.18-2a6.9,6.9,0,0,1,4,2.43c2.26,2.53,3.3,6,5.63,8.48a9.6,9.6,0,0,0,8.26,3.06c.1,0,.13-.21,0-.24a14.07,14.07,0,0,1-5.38-2.59,15.7,15.7,0,0,1-3.75-4.76c-1.72-3-3.39-6.26-6.64-7.76a6.06,6.06,0,0,0-4.56-.28,10.51,10.51,0,0,0-4,3.06,45.05,45.05,0,0,0-6.51,9.11A39.1,39.1,0,0,0,128.05,308.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.58,306.58a.34.34,0,0,0,.19.41l.13,0a.35.35,0,0,0,.29-.15A78.36,78.36,0,0,1,119.1,300a76.93,76.93,0,0,1,5.91-6.41,109.38,109.38,0,0,1,11.07-9.87,31.07,31.07,0,0,1,6.24-3.69c2.11-.92,5-2.17,7-.39a13.12,13.12,0,0,1,2.71,4.17c.28.58.56,1.14.85,1.67a40,40,0,0,0,4.27,6.38,22.46,22.46,0,0,0,5.59,4.91,14.52,14.52,0,0,0,6.74,2.2.32.32,0,0,0,.35-.27.31.31,0,0,0-.21-.38c-6.65-2.33-10.92-7.42-13.32-11.28-.67-1.08-1.28-2.25-1.85-3.37s-1.16-2.25-1.84-3.33c-1.45-2.35-3.31-3.55-5.49-3.62-2.62-.07-5.34,1.07-7.41,2.05a35.06,35.06,0,0,0-6.41,4,96.68,96.68,0,0,0-11.21,10.72C118.52,297.34,115,301.6,113.58,306.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,290.09c.33.16.53-.33.28-.53a36.88,36.88,0,0,1-8.54-9.17,29.19,29.19,0,0,1-3.84-10,30,30,0,0,1-.53-5.5c0-1.35-.35-4.76,1.63-4.77s3.07,2.37,4.22,3.51a15.14,15.14,0,0,0,4.57,3.18,9.8,9.8,0,0,0,10.46-1.37.12.12,0,0,0-.13-.2c-4.4,2.45-10.17.54-13.57-2.74-1.38-1.32-2.5-3.23-4.46-3.76a3,3,0,0,0-4,2.06,18.5,18.5,0,0,0-.34,5.61,27.48,27.48,0,0,0,.86,5.63C164.58,279.36,169.12,286.61,176,290.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.76,299.47a16.56,16.56,0,0,0-1.77,4.42.82.82,0,0,0,.47.92,1.06,1.06,0,0,0,.23.05.69.69,0,0,0,.62-.33c.59-.91,1.15-1.84,1.71-2.76a50.84,50.84,0,0,1,4-5.93,71.3,71.3,0,0,1,7.12-7.44,176.56,176.56,0,0,1,16.15-12c8-5.32,13.49-8.13,14.75-7.55.86.4.9,1.83.94,3a10.08,10.08,0,0,0,.05,1,45.66,45.66,0,0,0,.88,4.87,29.59,29.59,0,0,0,3.43,8.74,19.57,19.57,0,0,0,5.85,6.19c1.3.85,4.67,2.76,7.77,2.17A.45.45,0,0,0,173,294c-.51-.2-1-.38-1.51-.56a24.6,24.6,0,0,1-3.13-1.31,18.13,18.13,0,0,1-4-2.93,22.22,22.22,0,0,1-5.33-8.68,47.71,47.71,0,0,1-2-9.79,4.69,4.69,0,0,0-1.83-3.66c-1.18-.77-3.21-.24-4.21.19-5.74,2.46-24.18,14.24-31.53,21.06a46.73,46.73,0,0,0-6.15,7.16A42.72,42.72,0,0,0,110.76,299.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.16,290.06c3.85,1.67,8.41,0,11.92-1.74s6.4-4.09,9.69-6c.85-.48,1.7-.93,2.58-1.34.44-.2.89-.39,1.34-.56.23-.09.5-.26.74-.18s.29,0,.1.19-.12.17-.19.25c-1.14,1.42-2.93,2.44-4.3,3.62a52.7,52.7,0,0,0-7.6,7.92c-2.12,2.75-4.33,5.91-5,9.38,0,.17.2.23.29.11,1.35-1.84,2.48-3.84,3.82-5.69a43,43,0,0,1,4.35-5.08c1.41-1.42,2.88-2.79,4.37-4.12s3.06-2.47,4.4-3.88c.93-1,2.59-3,.77-4-1.47-.8-3.65.57-4.95,1.22-3.68,1.84-7,4.33-10.58,6.31a27.38,27.38,0,0,1-5.83,2.45,28.2,28.2,0,0,1-5.92.86C96,289.79,96,290,96.16,290.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.08,309.56a1.17,1.17,0,0,1,0-.11.24.24,0,0,1,.36-.12l.08.05c.35.13.58.64.71.94s.33.75.5,1.11c.33.72.62,1.46,1,2.17a.15.15,0,0,1-.23.19,6.43,6.43,0,0,1-1.78-1.82,8.55,8.55,0,0,1-.55-1.09,2.69,2.69,0,0,1-.19-.74A.94.94,0,0,1,142.08,309.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.75 201.68 60.75 201.68 60.75 166.62 95.81 166.62 95.81 169.62 63.75 169.62 63.75 201.68",
    style: {
      fill: "#002B44"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.89 320.75 179.83 320.75 179.83 317.75 211.89 317.75 211.89 285.69 214.89 285.69 214.89 320.75",
    style: {
      fill: "#002B44"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.81 320.75 60.75 320.75 60.75 285.69 63.75 285.69 63.75 317.75 95.81 317.75 95.81 320.75",
    style: {
      fill: "#002B44"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.89 201.68 211.89 201.68 211.89 169.62 179.83 169.62 179.83 166.62 214.89 166.62 214.89 201.68",
    style: {
      fill: "#002B44"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.61 328.48 220.24 328.48 220.24 327.73 221.86 327.73 221.86 326.11 222.61 326.11 222.61 328.48",
    style: {
      fill: "#002B44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.22,328.48h-4v-.75h4Zm-8,0h-4v-.75h4Zm-8,0h-4v-.75h4Zm-8,0h-4v-.75h4Zm-8,0h-4v-.75h4Zm-8,0h-4v-.75h4Zm-8,0h-4v-.75h4Zm-8,0h-4v-.75h4Zm-8,0h-4v-.75h4Zm-8,0h-4v-.75h4Zm-8,0h-4v-.75h4Zm-8,0h-4v-.75h4Zm-8,0h-4v-.75h4Zm-8,0h-4v-.75h4Zm-8,0h-4v-.75h4Zm-8,0h-4v-.75h4Zm-8,0h-4v-.75h4Zm-8,0h-4v-.75h4Zm-8,0h-4v-.75h4Zm-8,0h-4v-.75h4Z",
    style: {
      fill: "#002B44"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.4 328.48 53.03 328.48 53.03 326.11 53.78 326.11 53.78 327.73 55.4 327.73 55.4 328.48",
    style: {
      fill: "#002B44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.78,322.08H53v-4h.75Zm0-8H53v-4h.75Zm0-8H53v-4h.75Zm0-8H53v-4h.75Zm0-8H53v-4h.75Zm0-8H53v-4h.75Zm0-8H53v-4h.75Zm0-8H53v-4h.75Zm0-8H53v-4h.75Zm0-8H53v-4h.75Zm0-8H53v-4h.75Zm0-8H53v-4h.75Zm0-8H53v-4h.75Zm0-8H53v-4h.75Zm0-8H53v-4h.75Zm0-8.05H53v-4h.75Zm0-8H53v-4h.75Zm0-8H53v-4h.75Zm0-8H53v-4h.75Zm0-8H53v-4h.75Z",
    style: {
      fill: "#002B44"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.78 161.27 53.03 161.27 53.03 158.9 55.4 158.9 55.4 159.65 53.78 159.65 53.78 161.27",
    style: {
      fill: "#002B44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.22,159.65h-4v-.75h4Zm-8,0h-4v-.75h4Zm-8,0h-4v-.75h4Zm-8,0h-4v-.75h4Zm-8,0h-4v-.75h4Zm-8,0h-4v-.75h4Zm-8,0h-4v-.75h4Zm-8,0h-4v-.75h4Zm-8,0h-4v-.75h4Zm-8,0h-4v-.75h4Zm-8,0h-4v-.75h4Zm-8,0h-4v-.75h4Zm-8,0h-4v-.75h4Zm-8,0h-4v-.75h4Zm-8,0h-4v-.75h4Zm-8,0h-4v-.75h4Zm-8,0h-4v-.75h4Zm-8,0h-4v-.75h4Zm-8,0h-4v-.75h4Zm-8,0h-4v-.75h4Z",
    style: {
      fill: "#002B44"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.61 161.27 221.86 161.27 221.86 159.65 220.24 159.65 220.24 158.9 222.61 158.9 222.61 161.27",
    style: {
      fill: "#002B44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.61,322.08h-.75v-4h.75Zm0-8h-.75v-4h.75Zm0-8h-.75v-4h.75Zm0-8h-.75v-4h.75Zm0-8h-.75v-4h.75Zm0-8h-.75v-4h.75Zm0-8h-.75v-4h.75Zm0-8h-.75v-4h.75Zm0-8h-.75v-4h.75Zm0-8h-.75v-4h.75Zm0-8h-.75v-4h.75Zm0-8h-.75v-4h.75Zm0-8h-.75v-4h.75Zm0-8h-.75v-4h.75Zm0-8h-.75v-4h.75Zm0-8.05h-.75v-4h.75Zm0-8h-.75v-4h.75Zm0-8h-.75v-4h.75Zm0-8h-.75v-4h.75Zm0-8h-.75v-4h.75Z",
    style: {
      fill: "#002B44"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.37,444h92.34c.76-3,1.49-5.9,2.23-8.78q1.26-5,2.47-9.69c.17-.7.36-1.4.54-2.09.61-2.41,1.2-4.76,1.79-7,.35-1.4.7-2.77,1-4.12s.7-2.74,1-4.06c.09-.35.18-.71.27-1s.19-.77.28-1.14l.35-1.37h0c.13-.48.25-.95.36-1.42.24-.89.46-1.76.67-2.62.33-1.26.64-2.5.95-3.71.13-.52.27-1.05.4-1.56.22-.85.43-1.67.63-2.47.14-.54.27-1.07.4-1.58.55-2.12,1.05-4.11,1.52-6,.13-.49.24-1,.37-1.44.2-.81.4-1.58.59-2.33.13-.47.24-.92.35-1.37.41-1.59.78-3,1.1-4.31.09-.34.17-.67.26-1l.57-2.26c.07-.26.13-.52.2-.76s.13-.51.18-.73.09-.33.12-.47.12-.45.17-.63a1.63,1.63,0,0,1,.07-.28l.21-.84H293s-3,10.21-7.7,26.66c-1,3.35-2,7-3.11,10.8C279,417.3,275.33,430.1,271.37,444Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.59,444h2.3q5.13-21.22,9.94-42.51,1.16-5.18,2.29-10.37l.21-1a.14.14,0,0,0-.27-.07l-.09.32q-1.56,5.56-3.1,11.15C356,415.62,352.24,429.78,348.59,444Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.87,368.88l4,19.86L303.09,405l5.54,27.75.57,2.85.95,4.74.71,3.59h52.86c.75-3,1.49-5.91,2.22-8.78q1.26-5,2.47-9.69c.17-.7.36-1.4.54-2.09.61-2.41,1.2-4.76,1.79-7,.35-1.4.7-2.77,1-4.12s.7-2.74,1-4.06c.09-.35.18-.71.27-1s.19-.77.28-1.14l.35-1.37h0c.13-.48.25-.95.36-1.42.24-.89.46-1.76.67-2.62.33-1.26.64-2.5.95-3.71.14-.53.27-1.05.4-1.56.22-.85.43-1.67.63-2.47.14-.54.27-1.07.4-1.58.55-2.12,1.05-4.11,1.52-6,.13-.49.24-1,.37-1.44.2-.81.4-1.58.59-2.33.13-.47.24-.92.35-1.37.41-1.59.78-3,1.1-4.31.09-.34.17-.67.26-1l.57-2.26c.07-.26.13-.52.2-.76s.13-.51.18-.73.09-.33.12-.47.12-.45.17-.63a1.63,1.63,0,0,1,.07-.28l.21-.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.86,368.85v0c0,.5.38,5.86,1.24,14,.25,2.39.54,5,.88,7.82.53,4.44,1.18,9.33,2,14.5,1.38,9,3.18,18.86,5.52,28.48.83,3.46,1.75,6.89,2.72,10.25l116,0c-1.37-17.68-2.62-33.67-3.61-46.27-1.4-17.74-2.28-28.85-2.28-28.85l-105.24,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.11,379.51c.13,4.15.3,8.3.57,12.43.28,4.48.69,8.95,1.28,13.42a4.36,4.36,0,0,0,.06.49q.83,6.28,1.88,12.53c.67,3.88,1.16,8.07,2.88,11.67a11.56,11.56,0,0,0,2.71,3.66,8.12,8.12,0,0,0,3.71,1.92,4,4,0,0,0,.69.11c.06,0,.13,0,.2,0a.24.24,0,0,0-.13.24c.05,1.39,0,2.81.17,4.19,0,.06,0,.12,0,.18.14,1.2.36,2.39.58,3.59h2s0,0,0-.07c-.35-1.31-.64-2.63-1-4s-.8-2.66-1.11-4a.22.22,0,0,0-.1-.13,6.18,6.18,0,0,0,6-3.76,10.71,10.71,0,0,0,.1-5.45l-1.08-7.13c-.68-4.36-1.55-8.68-2.33-13-.11-.66-.23-1.32-.35-2-1.55-8.83-3.18-17.67-5.13-26.42-.07-.36-.16-.72-.24-1.09s-.44-.17-.42.06c.06.59.12,1.18.19,1.77.34,3.36.74,6.7,1.2,10,.56,3.92.95,7.86,1.5,11.78l.57,4c.9,6.45,1.84,12.9,2.94,19.32.52,3,2.38,8.33-1.92,9.26a4.34,4.34,0,0,1-2.91-.37,9.1,9.1,0,0,1-4-5c-1.22-3.42-1.65-7.18-2.28-10.74q-1.07-5.89-1.88-11.81h0c-.7-4.92-1.42-9.84-2.2-14.75-.38-2.51-.78-5-1.18-7.52-.18-1.15-.37-2.31-.56-3.47C296.49,379.19,296.11,379.26,296.11,379.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.77,410.35a58.58,58.58,0,0,1-14.31-1.92c-2.16-.56-4.29-1.25-6.4-1.94a16.82,16.82,0,0,1-5.78-2.9c-3.25-2.81-4.77-7.23-6.18-11.15a107.6,107.6,0,0,1-3.75-13.53c-.05-.23-.38-.16-.39.06a52.9,52.9,0,0,0,2,15.37c1.17,4.24,2.74,9,6.17,12,3.6,3.12,8.5,4.22,13.11,4.79a60.35,60.35,0,0,0,15.6-.21A.26.26,0,0,0,398.77,410.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.81,379q.39,9.75.82,19.5,1,22.71,2.19,45.42H412q-1.5-22.77-3.15-45.49-.72-9.74-1.48-19.44A.28.28,0,0,0,406.81,379Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.74,235.16c-45.7,41.19-88.07,86.3-91.39,109.32-4.59,31.88,15,40.73,23.8,40.81,23.92.24,67.39-96.7,82.51-133.71C338.34,215.64,318.78,226.11,308.74,235.16Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.76,301.08l50.82,27.62s31.59-58.36,38.87-85.41S325.86,217,302,238.06,239.76,301.08,239.76,301.08Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.76,301.08l50.82,27.62s31.59-58.36,38.87-85.41S325.86,217,302,238.06,239.76,301.08,239.76,301.08Z",
    style: {
      fill: "#002B44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.45,243.28c-7.28,27.06-38.88,85.43-38.88,85.43L244.3,303.55l85.22-80.1C332.36,225.63,332.48,232.06,329.45,243.28Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.22,293.29c19.59,13.26,38.58,21.87,42.39,24.06.18.11.33-.19.14-.29-3.85-1.95-24.7-14.93-42.38-24.09C250.17,292.86,250,293.16,250.22,293.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.12,404.91l148.81.43s-13-112-67.62-178.11c-12.64-15.31-33-7-41.59,1.14C296.92,249,278.7,404.37,279.12,404.91Z",
    style: {
      fill: "#002B44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.31,221.14c3.57,2.61,7,5.49,10.43,8.16l10,7.75c3,2.35,6,5,9.41,6.85,3.07,1.68,6.64,2.43,9.93.93a10.87,10.87,0,0,0,2.25-1.4l.34.53a10.41,10.41,0,0,1-5.92,2.38c-3.29.19-6.36-1.31-9-3.11-3.34-2.26-6.45-4.87-9.64-7.34-6.19-4.79-12.3-9.79-18.66-14.37C329.7,221.39,330,221.26,330.31,221.14Zm59.35,89.09a83.65,83.65,0,0,1,15.7,1.39c-.12-.35-.25-.71-.39-1.06a79,79,0,0,0-13.79-1.29c-13.47-.25-31.49.59-39.63-12.61-3.21-5.2-4.25-12.11-.72-17.44,3.11-4.7,8.92-6.73,14.37-6.68a22.47,22.47,0,0,1,8.29,1.64A32.85,32.85,0,0,1,382,279.8c4.84,4.12,9.35,8.95,15.41,11.24l-.48-1.16a26.11,26.11,0,0,1-5.1-2.91c-5.63-4.07-10.18-9.71-16.44-12.89a22.88,22.88,0,0,0-15.51-1.85c-5,1.21-9.45,4.46-11.3,9.41-2.06,5.52-.45,11.84,2.84,16.55C359.88,310.26,376.53,310.06,389.66,310.23Zm-22.84-51.46A88.85,88.85,0,0,1,379,254c-.18-.29-.36-.6-.55-.89-9.6,2.69-18.47,8.76-28.37,10.46a50.06,50.06,0,0,1-34.59-7.13,48.27,48.27,0,0,1-7.84-6.11c-.12.32-.23.64-.34,1a50.74,50.74,0,0,0,7.42,5.78,51.32,51.32,0,0,0,33.46,7.78C354.76,264,360.8,261.49,366.82,258.77Zm9,106.25a184.73,184.73,0,0,0,22.45,6.54c8.44,2,18.88,3.68,25.7,9.39-.09-.49-.19-1-.29-1.47-6.81-5.19-16.58-6.85-24.71-8.75a192.08,192.08,0,0,1-22.53-6.54c-6.33-2.33-12.59-5.46-17.22-10.51a21.6,21.6,0,0,1-5.78-16c.39-5.9,3.75-11.27,9.56-13.11,6.23-2,13.18.35,18.38,3.9,5.94,4.07,10.21,10.18,14.78,15.62,4.33,5.19,9.13,10,15.46,12.62a22.56,22.56,0,0,0,7.48,1.75c-.07-.29-.13-.6-.21-.9-5.05-.32-10-2.8-13.92-5.84-5.77-4.46-9.91-10.67-14.66-16.13-4.35-5-9.33-9.44-15.75-11.52-5.56-1.8-11.95-1.62-16.65,2.21-4.1,3.36-5.73,8.8-5.45,13.95a23,23,0,0,0,6.74,14.92C363.78,359.78,369.76,362.76,375.81,365Zm-18.09,25.47c-1.06,4.83-.56,9.77-.85,14.65h.92v0c.35-6-.6-12.27,1.89-17.92a10.81,10.81,0,0,1,6.63-6.16,14,14,0,0,1,9.9,1.11c6.46,3.16,9.91,10,13.05,16.08,1.22,2.33,2.47,4.74,3.91,7h1.08c-3.56-5.4-5.83-11.56-9.67-16.8-3.71-5-9.29-9.14-15.84-8.7C362.68,380.16,358.94,384.88,357.72,390.49ZM299.39,405h1.18a25.56,25.56,0,0,0,2.82-7.53c1.44-6.64,1-13.51.54-20.23-1.1-15.57-3.79-31.47-.38-46.94a52.28,52.28,0,0,1,7.28-17.81c3.68-5.5,9-10.67,15.43-12.77a13.41,13.41,0,0,1,10.49.49,14.58,14.58,0,0,1,6.18,6.8c3.25,6.92,1.24,14.75-1.86,21.33C335,341.18,325.15,352,320.26,365.46a46.64,46.64,0,0,0,2.38,37.06c.44.85.9,1.69,1.39,2.52h1.09a45.88,45.88,0,0,1-5.32-12.73,44.86,44.86,0,0,1-.62-19.53c1.36-7,4.47-13.43,8-19.51s7.74-12,11.33-18.21,7.07-13.18,7-20.59c-.07-5.72-2.73-11.78-7.79-14.77-6-3.56-13.19-1.14-18.44,2.6-10.33,7.37-15.57,19.74-17.49,31.94-2.5,15.92.63,32,1.38,47.94.31,6.36.29,12.93-1.94,19A19.36,19.36,0,0,1,299.39,405Zm14.92-134.4a18.79,18.79,0,0,0-11.45-4.44c-.07.26-.14.54-.22.8a20.39,20.39,0,0,1,3,.37c6.14,1.22,12.36,6,12.43,12.75.09,7.35-6.15,12.81-12.19,15.85-3.54,1.78-7.25,3.16-10.88,4.69-.06.32-.13.63-.19,1,2.3-1,4.64-1.86,7-2.82,6.25-2.56,12.55-6,15.66-12.3A12.92,12.92,0,0,0,314.31,270.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.76,232.23C414.1,265.5,459.29,322,460,354.58c.67,32.2-17.42,29-20.46,28-32.2-10-71-99.35-85.38-135.72C339.88,210.79,360,224,370.76,232.23Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.39,297.13l-50.32,28.53s-32.64-57.79-40.4-84.71,3.13-26.33,27.41-5.72S440.39,297.13,440.39,297.13Z",
    style: {
      fill: "#002B44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.79,289.53c-19.36,13.6-38.19,22.56-42,24.81-.18.11-.33-.19-.15-.29,3.81-2,24.43-15.37,41.94-24.84C429.83,289.1,430,289.4,429.79,289.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.3,323.69a30.1,30.1,0,0,0-3,1.35c-4.83-9.61-3.95-7.41-8.88-17q-3.61-7-7.24-14.07c-2.5-4.88-4.74-10-7.5-14.7a.12.12,0,0,0-.22.11c1.6,4.62,3.77,9.1,5.82,13.56-.45-.69-.88-1.4-1.38-2.07-1.11-1.49-2.2-3-3.18-4.56-.16-.24-.56-.05-.41.2,1,1.5,1.78,3.05,2.61,4.63s1.74,3.07,2.67,4.59,1.9,2.84,2.9,4.23l.36.52c1.32,2.79,2.6,5.59,4,8.35,4.84,9.67,9.82,17.28,10,17.23a26.13,26.13,0,0,0,3.65-2.12C393.58,323.86,393.44,323.68,393.3,323.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.36,384.16c14.92-2.18,23.37-29.89,39.93-74,2.9-7.74-35.61-52.07-40.84-44.94-6.59,9-24,58.79-25.78,72.33C213.24,364.23,226,386.71,243.36,384.16Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.31,354.79c1.34-3.75,2.76-7.47,4.19-11.19l4.33-11.13c1.5-3.69,2.94-7.4,4.39-11.1q1.11-2.78,2.14-5.57c.71-1.86,1.4-3.73,1.93-5.65a80.26,80.26,0,0,1-3.35,11.48c-1.31,3.77-2.76,7.49-4.18,11.21s-3,7.39-4.56,11.05S268,351.2,266.31,354.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.63,297.19c2.09-15.14,6.36-36.26,11.77-40.69,5.68-4.64,26.31-20.17,32.26-22.23s32.51-12.17,37.39-9.35c3.91,2.26-.72,12.53-13.35,17.46-11.11,4.32-16.83,8.36-20,9.73s-11,11.89-8.9,16.53c1.25,2.73,9.21,5.94,14.16,3.7s6.17-12,11.82-16.65,15.63-4.06,16.21-1.37-2.72,3.95-7.82,13.11c-3.28,5.88-3.5,20-10.94,30.14C287.49,302.66,281,316.2,281,316.2Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.06,251.51a9.73,9.73,0,0,0,4.94-2.24,4,4,0,0,0,1.13-2,4.09,4.09,0,0,0,0-1.26,1.92,1.92,0,0,0-.48-1.21c-.1-.07.05-.19.1-.09a5.22,5.22,0,0,0,.45.6,3.06,3.06,0,0,1,.29.57,3.27,3.27,0,0,1,.21,1.24,4.1,4.1,0,0,1-1,2.51,6.8,6.8,0,0,1-5.68,2C299,251.66,299,251.53,299.06,251.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.4,256.5c4.81-7.55,17.12-21.19,29.32-25.87,8.24-3.17,36.62,10.63,35.8,16.05s-5.67,5.45-12.85,4.6c-2.61-.31-16.44-5.27-18.8-2.37-3.38,4.18-7.68,18.43-7.68,18.43Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.81,244.56c-3.51-5.8-11.21-8.89-18.88-11.33-.12,0-.19.14-.07.18,1.95.62,14.45,6.36,18.87,11.25C304.78,244.71,304.85,244.62,304.81,244.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.4,256.5c4.81-7.55,17.12-21.19,29.32-25.87,8.24-3.17,30.7,14.49,29.87,19.92s-7.78,5.86-15.48,3.19c-2.49-.87-10.83-6.73-13.19-3.83-3.38,4.17-11.63,14.53-11.63,14.53Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264,258c.78-1.19,1-1.61,1.83-2.79s1.6-2.34,2.48-3.45a10.63,10.63,0,0,1,2.54-2.68,5.5,5.5,0,0,1,3.4-.68c2.67.25,5.08,1.94,7.35,3.24,2.53,1.45,7.77,3.8,11.79,3.37a8,8,0,0,0,3.17-.86,4.94,4.94,0,0,0,1.89-1.52c1.74-3-.44-6.32-2.66-8.71-4.15-4.45-9.73-7.67-15.14-10.32-1.33-.65-2.67-1.26-4-1.88a12,12,0,0,0-4.87-1.39c-2.79,0-7.36,2.82-8.77,3.68-.11.06-.19-.11-.09-.18,1.72-1.07,6-4.55,10.46-4.33a14.22,14.22,0,0,1,4.69,1.58c1.57.67,3.12,1.4,4.65,2.16a64.87,64.87,0,0,1,8.58,5.07c2.56,1.83,5.29,4,7,6.63a7.82,7.82,0,0,1,.5,8c-1.23,2-3.86,2.54-5.06,2.7a13.61,13.61,0,0,1-3.55,0,56.62,56.62,0,0,1-7.72-2.25c-2.44-1-4.64-2.62-7.15-3.38a4.7,4.7,0,0,0-3.64.25,12.32,12.32,0,0,0-2.72,2.48,37.67,37.67,0,0,0-4.54,5.39C264.09,258.69,263.72,258.52,264,258Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.84,263.1c1.76-3.6,4.73-18.42,7.59-23s15.9-20.27,22-19.59c7.67.85-.31,14.66-4.32,20.35s-3.32,15.36-3.32,15.36Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.7,231.47c-1.43,1.8-2.69,3.8-3.93,5.73a45,45,0,0,0-3.42,5.64,19.85,19.85,0,0,0-1.49,6.31c-.1,1.07-.13,2.13-.14,3.2s.1,2.35.08,3.51a.1.1,0,1,0,.19,0,48.39,48.39,0,0,1,.83-6.35,26.75,26.75,0,0,1,1.91-6.33c1.79-4,4.41-7.6,6.23-11.59C268,231.44,267.8,231.34,267.7,231.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.88,257.88a18.42,18.42,0,0,0,1.11,5.25,38.39,38.39,0,0,0,2.06,5,48.73,48.73,0,0,0,2.59,4.7c.92,1.53,2,2.91,3.13,4.37a34.69,34.69,0,0,1,5.43,9.47A31.19,31.19,0,0,1,275,297.34a37.83,37.83,0,0,0-2.5-10.44,39.65,39.65,0,0,0-5.53-9.15,44.55,44.55,0,0,1-3.16-4.45,41.43,41.43,0,0,1-2.5-4.87C259.93,265.1,258.65,261.54,258.88,257.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.59,236.72a70.36,70.36,0,0,0,1,7,35.29,35.29,0,0,0,1.63,6.19c1.43,3.61,4.16,7,8.37,7.93a14.89,14.89,0,0,0,11.35-2.43c3.49-2.3,6.21-5.56,8.7-8.73q2.33-2.94,4.37-6.06c.68-1.06,1.38-2.1,2-3.19s1.21-2.19,1.91-3.23c.06-.09.24,0,.19.07-1.36,2.46-5.44,10.26-6.8,12.19-2.49,3.52-5.2,7.11-8.81,9.71a16.74,16.74,0,0,1-12.12,3.3,12.28,12.28,0,0,1-9.42-7.37,25.35,25.35,0,0,1-1.81-7.22c-.34-2.72-.52-5.46-.64-8.19C313.53,236.69,313.59,236.69,313.59,236.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,251.05c9.18-.25,20.5-17.36,23.52-29.59.2-.84-10.62-29.31-12.18-35.18C339,185.08,304.87,205,304.87,205s6.89,11.33,9.54,21.57C314.62,227.43,319.12,251.29,328,251.05Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.87,205s6.89,11.33,9.54,21.58c0,.2.34,1.69.87,3.85,17.07-6.27,25.36-20,29.16-29.23-2.33-6.46-4.48-12.53-5.1-14.9C339,185.08,304.87,205,304.87,205Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.27,138.65c-2.19.37-9.54,17.83-8.47,25.47s6.06,22.44,8.34,22.37S287,138.36,285.27,138.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.79,145.42c7.54,11.93,10.95,51.41,4,62.33-10.11,15.83-31.8,23-46.55,9.71-14.31-12.9-17.85-64.43-9.58-74.88C297.82,127.19,326.65,127.8,337.79,145.42Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.42,170.63a34.39,34.39,0,0,0,3.51.31c1.35.1,2.42.33,3.65-.36a1.83,1.83,0,0,0,.64-2.13c-.7-1.57-2.32-2.11-3.94-2.3a6.64,6.64,0,0,0-4.66,1A1.94,1.94,0,0,0,309.42,170.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,179.25c0-.11.22.1.23.21.19,2.67.86,5.69,3.35,6.33.08,0,.09.15,0,.15C311.56,185.83,310.71,181.8,311,179.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.05,176.23c4.25-.77,5.46,7.78,1.53,8.48S309.5,176.87,313.05,176.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.68,181c0-.1-.19.16-.17.26.46,2.64.54,5.73-1.73,6.95-.07,0,0,.17,0,.15C296.69,187.57,296.53,183.46,295.68,181Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.92,178.61c-4.3.29-3.42,8.87.56,8.61S296.53,178.38,292.92,178.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,174.06a34.64,34.64,0,0,0,3.27-1.36c1.25-.54,2.3-.84,3.07-2a1.84,1.84,0,0,0-.42-2.19c-1.35-1.07-3.05-.79-4.58-.21a6.65,6.65,0,0,0-3.66,3.09A1.94,1.94,0,0,0,289,174.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.46,200.89c-.54.71-1,1.65-2,1.87a7,7,0,0,1-2.94-.26.09.09,0,0,0-.1.15,3.6,3.6,0,0,0,3.57,1,2.85,2.85,0,0,0,1.75-2.63C316.75,200.82,316.54,200.79,316.46,200.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.56,193.36a9.12,9.12,0,0,1-5.45,4.87,11.62,11.62,0,0,1-3.22.61,3.33,3.33,0,0,1-.63,0,5.8,5.8,0,0,1-.59,0,.67.67,0,0,1-.62-.52v0a1.22,1.22,0,0,1,0-.27v0l0-.23c-.35-2-.59-5.16-.59-5.16-.69.48-4.25,2.72-4.34,1.65-.72-8.89-1.53-18.77-.38-27.76a.25.25,0,0,1,.49,0c1,8.52.57,17.16,1.48,25.72a15.88,15.88,0,0,1,4.07-1.89c.3,0,.36,6,.59,6.95a.19.19,0,0,0,0,.09c3.48,0,5.92-1.45,8.91-4.22C312.45,193,312.68,193.13,312.56,193.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.42,179.31c-6.88,1.55-11.34-5.74-15.18-16.25-2.25-6.15-2.26-19-2.26-19s-16.68,10.72-26.89,11.18-20-7.07-20.6-15c-.51-6.85,9.76-17.21,24.74-19.87,10.45-1.85,29.33,4.2,38.68,14.45,0,0,14.07,4.55,13.44,14.8S350.23,177.55,342.42,179.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.82,178.58c-8.91,3.17-15.61-10-16.8-17.15-1.24-7.45.62-15.4.94-22.87,0,0-.06,0-.06,0-1.92,9.27-3.78,20.92.48,29.77,2.68,5.58,8.25,14.65,15.62,10.74C342.25,178.93,342.1,178.48,341.82,178.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,146.3c-2.11-6-9.94-11.11-16-11.76-.06,0-.08.09,0,.1,7.38,1.62,16.62,8.65,15.49,16.84-.91,6.54-2.83,15.25-6.46,20.83-.09.14.12.27.22.14,2.94-3.83,3.83-8.44,5-13C355.22,155.42,357.42,150.45,356,146.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.37,135.54c-9.88-10.8-29.61-21.92-44.41-16.22,0,0,0,.09,0,.07,15.9-4.65,32.4,7.2,43.91,16.72C342.23,136.39,342.65,135.84,342.37,135.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338,180.32s5.35-14.43,11.69-12.84,4.54,21-1.33,25.07a6.84,6.84,0,0,1-9.79-1.23Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.07,173c.11,0,.16.1.08.17-4.07,3-5.37,7.89-5.9,12.71.91-2,2.52-3.45,5.2-2.43.14.05.08.27-.06.27a4.22,4.22,0,0,0-4.11,2.59,20.8,20.8,0,0,0-1.19,4.18c-.11.47-.9.44-.87-.07a.45.45,0,0,1,0-.11C340.59,184.55,343,175.24,349.07,173Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.71,244.35l21,62.61c.82,1.82,0,3.41-1.84,3.55L305.91,313a5.34,5.34,0,0,1-4.83-3l-21-62.61c-.82-1.83,0-3.42,1.84-3.56l32.94-2.53A5.36,5.36,0,0,1,319.71,244.35Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.79,244.61l21,62.61c.82,1.82,0,3.42-1.84,3.56L302,313.31a5.36,5.36,0,0,1-4.83-3.05l-21-62.61c-.83-1.82,0-3.41,1.84-3.55L311,241.57A5.34,5.34,0,0,1,315.79,244.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,248.22a2.81,2.81,0,1,0,2.52-3.07A2.81,2.81,0,0,0,307,248.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.34,383C432,385.09,413.9,374.1,367,340.66,360.5,336,380.84,281.43,388,286c9.05,5.77,42.92,30.15,45.17,32.25C452.2,336,456.09,381.5,446.34,383Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.83,302.27s-13.46-18.44-23.53-25.95c-13.49-10-29.27-13.16-36-14.07-14-1.9-49,3.17-49.35,13.53-.28,9.38,35.32,2.38,35.32,2.38s-37.47,1.14-35.73,12.49,42.62.89,42.62.89-38.48,2-34.83,13.46c2.76,8.63,40.31,1.23,40.31,1.23s-33.06,2-30.61,11c2.72,9.94,37.8,5.29,37.8,5.29C361,344.32,374.7,350.59,385,353.88,387.49,354.67,404.83,302.27,404.83,302.27Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.25,276.94c-4.41,0-8.87-.08-13.26.28s-8.78.89-13.12,1.66c-10.65,1.9-17,4.76-16.6,4.62,9.76-3.15,25.46-4.71,29.86-5.08s8.75-.95,13.14-1.32C344.38,277.09,344.35,276.94,344.25,276.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.86,292.78c-5.63.21-11.22.21-16.84.67s-10.86,1.39-16.41,2.23c-.43.06-.25.27.18.22,5.57-.62,10.78-.76,16.36-1.31s11.15-1.33,16.73-1.68C346,292.91,346,292.78,345.86,292.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.69,306.13c-8.62-.12-17.25,1.35-25.68,3-.42.08-.16.33.27.27,8.52-1.16,15.19-2.13,25.41-3C349.84,306.41,349.87,306.13,349.69,306.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.25,308.63c3.72,2.45,7.3,5.1,10.77,7.91a65.84,65.84,0,0,1,5,4.43,27.28,27.28,0,0,1,4.31,5.21,70.69,70.69,0,0,1,5.79,12.1,60.51,60.51,0,0,1,3.38,12.93,59.15,59.15,0,0,0-1.8-6.41c-.69-2.11-1.45-4.19-2.3-6.24a76.08,76.08,0,0,0-5.92-11.84,25.42,25.42,0,0,0-4.1-5.1c-1.55-1.57-3.22-3-4.88-4.5s-3.38-2.88-5.1-4.29S422,310,420.25,308.63Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icons--inject-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.27,112.63s-4.11,32.9-10.87,40.31c-8.11,8.88-14,7.58-17.27,12.16h0c-3.28-4.59-9.16-3.28-17.28-12.17C226.1,145.53,222,112.63,222,112.63c17.8-8.64,28.14-18.33,28.14-18.33h0C250.45,94.61,260.74,104.12,278.27,112.63Z",
    style: {
      fill: "#002B44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13,94.31V165.1h0c-3.28-4.59-9.16-3.28-17.28-12.17C226.1,145.53,222,112.63,222,112.63c17.8-8.64,28.14-18.33,28.14-18.33Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.27,112.63s-4.11,32.9-10.87,40.31c-8.11,8.88-14,7.58-17.27,12.16V94.31C250.45,94.61,260.74,104.12,278.27,112.63Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.9,115.28s-3.47,27.8-9.18,34.05c-6.85,7.52-11.83,6.41-14.59,10.28-2.77-3.87-7.74-2.76-14.6-10.28-5.71-6.25-9.17-34.05-9.17-34.05,15-7.3,23.77-15.48,23.77-15.48S258.86,108,273.9,115.28Z",
    style: {
      fill: "#002B44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13,99.81v59.8h0c-2.76-3.87-7.74-2.77-14.59-10.28-5.71-6.26-9.17-34.06-9.17-34.06,15-7.3,23.76-15.48,23.76-15.48Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.48,
    y: 124.41,
    width: 21.3,
    height: 19.32,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.65,130.38h-2.17v-8.63a6.35,6.35,0,0,0-12.7,0v8.63h-2.17v-8.63a8.52,8.52,0,1,1,17,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.8,134.4l.69,3.26h-2.92l.69-3.26a1.46,1.46,0,1,1,1.54,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.5,242.76h-4.26V242h3.89v.26h.37Zm-8.26,0h-4V242h4Zm-8,0h-4V242h4Zm-8,0h-4V242h4Zm24.26-4.49h-.75v-4h.75Zm0-8h-.75v-4h.75Zm0-8h-.75v-4h.75Zm0-8h-.75v-4h.75Zm0-8h-.75v-4h.75Zm0-8h-.75v-4h.75Zm0-8h-.75v-4h.75Zm0-8h-.75v-4h.75Zm0-8h-.75v-4h.75Z",
    style: {
      fill: "#002B44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.82,169.45a1.69,1.69,0,1,0-1.69,1.69A1.69,1.69,0,0,0,251.82,169.45Z",
    style: {
      fill: "#002B44"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.55 124.83 53.24 124.83 53.24 58.96 91.34 58.96 104.55 71.52 104.55 124.83",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.34 58.96 104.55 71.52 91.34 71.52 91.34 58.96",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.24,
    y: 70.02,
    width: 28.53,
    height: 1.69,
    transform: "translate(145.02 141.72) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.24,
    y: 74.29,
    width: 28.53,
    height: 1.69,
    transform: "translate(145.02 150.26) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.24,
    y: 78.55,
    width: 28.53,
    height: 1.69,
    transform: "translate(145.02 158.8) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.24,
    y: 82.82,
    width: 41.8,
    height: 1.69,
    transform: "translate(158.29 167.34) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.24,
    y: 87.09,
    width: 41.8,
    height: 1.69,
    transform: "translate(158.29 175.88) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.24,
    y: 91.36,
    width: 41.8,
    height: 1.69,
    transform: "translate(158.29 184.42) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.24,
    y: 95.63,
    width: 41.8,
    height: 1.69,
    transform: "translate(158.29 192.96) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.24,
    y: 99.9,
    width: 41.8,
    height: 1.69,
    transform: "translate(158.29 201.49) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.24,
    y: 104.17,
    width: 41.8,
    height: 1.69,
    transform: "translate(158.29 210.03) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.24,
    y: 108.44,
    width: 41.8,
    height: 1.69,
    transform: "translate(158.29 218.57) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.24,
    y: 112.71,
    width: 41.8,
    height: 1.69,
    transform: "translate(158.29 227.11) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.24,
    y: 116.98,
    width: 41.8,
    height: 1.69,
    transform: "translate(158.29 235.65) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.55,
    cy: 122.52,
    r: 9,
    transform: "translate(-39.09 49.66) rotate(-22.63)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.09,
    y: 120.25,
    width: 8.92,
    height: 8.1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.12,122.74h-.91v-3.61a2.66,2.66,0,0,0-5.32,0v3.61H101v-3.61a3.57,3.57,0,0,1,7.14,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.93,124.39l.37,1.78h-1.58l.37-1.78a.79.79,0,1,1,.84,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.71,159.27H139v-4h.75Zm0-8H139v-4h.75Zm0-8H139v-4h.75Zm0-8H139v-4h.75Zm0-8H139v-4h.75Zm0-8H139v-4h.75Zm0-8H139v-4h.75Zm0-8H139v-4h.75ZM136,99h-4v-.75h4Zm-8,0h-4v-.75h4Zm-8,0h-4v-.75h4Zm-8,0h-1.73v-.75H112Z",
    style: {
      fill: "#002B44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.31,97A1.7,1.7,0,1,0,112,98.66,1.7,1.7,0,0,0,110.31,97Z",
    style: {
      fill: "#002B44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.46,381.71h-2.35V381h2.35Zm-6.35,0h-4V381h4Zm-8,0h-4V381h4Zm-8,0h-4V381h4Zm-6.4-1.6H139v-4h.75Zm0-8H139v-4h.75Zm0-8H139v-4h.75Zm0-8H139v-4h.75Zm0-8H139v-4h.75Zm0-8H139v-4h.75Zm0-8H139v-4h.75Z",
    style: {
      fill: "#002B44"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.37,
    cy: 381.34,
    r: 1.69,
    style: {
      fill: "#002B44"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.28,
    y: 370.37,
    width: 63.9,
    height: 38.56,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.3,
    y: 375.22,
    width: 17.86,
    height: 22.84,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188.23,
    cy: 384.36,
    r: 4.23,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.16,398.06H179.3s.49-4.26,1.36-5.53,3.17-2.7,7.57-2.7,6.7,1.43,7.57,2.7S197.16,398.06,197.16,398.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.78,
    y: 375.22,
    width: 29.4,
    height: 1.11,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.78,
    y: 386.08,
    width: 29.4,
    height: 1.11,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.78,
    y: 389.28,
    width: 29.4,
    height: 1.11,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.78,
    y: 392.47,
    width: 29.4,
    height: 1.11,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.78,
    y: 395.67,
    width: 29.4,
    height: 1.11,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.78,
    y: 398.86,
    width: 29.4,
    height: 1.11,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.78,
    y: 378.42,
    width: 23.81,
    height: 1.11,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.18,
    cy: 408.93,
    r: 9,
    transform: "translate(-139.01 123.14) rotate(-22.63)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.72,
    y: 406.66,
    width: 8.92,
    height: 8.1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.75,409.15h-.91v-3.61a2.66,2.66,0,0,0-5.32,0v3.61h-.91v-3.61a3.57,3.57,0,0,1,7.14,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.56,410.8l.37,1.78h-1.59l.38-1.78a.79.79,0,1,1,1.21-.67A.79.79,0,0,1,238.56,410.8Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetpassword);
export default __webpack_public_path__ + "static/media/resetpassword.990afa1561b84ac48026ea1ba8264110.svg";
export { ForwardRef as ReactComponent };